import { render, staticRenderFns } from "./videoProject.vue?vue&type=template&id=4ffc2915&scoped=true"
import script from "./videoProject.vue?vue&type=script&lang=js"
export * from "./videoProject.vue?vue&type=script&lang=js"
import style0 from "./videoProject.vue?vue&type=style&index=0&id=4ffc2915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc2915",
  null
  
)

export default component.exports